export const deriveInitalValues = (tId:any,domain:string,apiKey:string) =>{
    return  {
        tId: tId?tId:'',
        domain:domain?domain:'',
        apiKey:apiKey?apiKey:''
      }

}